const ALLOWED_TAGS = new Set([
  "P",
  "BR",
  "STRONG",
  "B",
  "EM",
  "I",
  "U",
  "UL",
  "OL",
  "LI",
  "H1",
  "H2",
  "H3",
  "H4",
  "H5",
  "H6",
  "A",
]);

const normalizeLink = (value) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return "";
    return parsed.toString();
  } catch (_error) {
    return "";
  }
};

const sanitizeElement = (element) => {
  const children = [...element.children];

  children.forEach((child) => {
    sanitizeElement(child);

    if (!ALLOWED_TAGS.has(child.tagName)) {
      const fragment = document.createDocumentFragment();
      while (child.firstChild) {
        fragment.appendChild(child.firstChild);
      }
      child.replaceWith(fragment);
      return;
    }

    [...child.attributes].forEach((attr) => {
      const name = attr.name.toLowerCase();
      if (name.startsWith("on") || (child.tagName !== "A" && name !== "style")) {
        child.removeAttribute(attr.name);
      }
    });

    if (child.tagName === "A") {
      const href = normalizeLink(child.getAttribute("href"));
      if (!href) {
        child.removeAttribute("href");
      } else {
        child.setAttribute("href", href);
        child.setAttribute("target", "_blank");
        child.setAttribute("rel", "noopener noreferrer");
      }

      [...child.attributes].forEach((attr) => {
        const safeNames = new Set(["href", "target", "rel"]);
        if (!safeNames.has(attr.name.toLowerCase())) {
          child.removeAttribute(attr.name);
        }
      });
    } else {
      child.removeAttribute("style");
    }
  });
};

export const sanitizeRichTextHtml = (value) => {
  const raw = String(value || "");
  if (!raw.trim() || typeof window === "undefined") return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${raw}</div>`, "text/html");
  const root = doc.body.firstElementChild;
  if (!root) return "";

  sanitizeElement(root);

  return root.innerHTML;
};

export const getPlainTextFromHtml = (value) => {
  const sanitized = sanitizeRichTextHtml(value);
  if (!sanitized || typeof window === "undefined") return "";
  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${sanitized}</div>`, "text/html");
  return (doc.body.textContent || "").trim();
};
